import Wording from './fr_wording.conf';

export const htmlTitle = {
  '/ident': Wording['WLOST-273'],
  '/choice': Wording['WLOST-274'],
  '/letter': 'Saisie du code postal, envoi par courrier | Mot de passe oublié Orange',
  '/otc': Wording['WLOST-275'],
  '/password': Wording['WLOST-276'],
  '/contact': Wording['WLOST-277'],
  '/confirm': Wording['WLOST-278'],
  '/error': 'Désolé, nous ne pouvons pas répondre à votre demande | Mot de passe oublié Orange',
};

export const title = {
  ident: Wording['WLOST-004'],
  getCode: Wording['WLOST-039'],
  letter: Wording['WLOST-039'],
  otc: 'Votre code reçu',
  setSmsCode: 'Saisissez votre code reçu par SMS',
  setMailCode: 'Saisissez votre code reçu par email',
  otcReceivedBySms: Wording['WLOST-084'],
  otcReceivedByMail: Wording['WLOST-085'],
  password: Wording['WLOST-094'],
  contact: 'Moyens de contact',
  confirm: Wording['WLOST-138'],
  appTitle: Wording['WLOST-001'],
  technicalError: Wording['WLOST-188'],
  maxCodeAttempts: Wording['WLOST-090'],
  smsWasResent: Wording['WLOST-076'],
  mailWasResent: Wording['WLOST-077'],
  passwordAvailableLater: Wording['WLOST-105'],
  passwordIsSaved: Wording['WLOST-148'],
  letterIsPending: Wording['WLOST-168'],
  letterWillBeSent: Wording['WLOST-172'],
  postalCodeAttemptsExceeded: Wording['WLOST-164'],
  accessRestricted: Wording['WLOST-182'],
  accountAccess: Wording['WLOST-020'],
  codeAttemptsExceeded: Wording['WLOST-086'],
  codeExpired: 'Le code de réinitialisation a expiré',
  serviceDenied: Wording['WLOST-109'],
  errorApi: 'Erreur API',
  errorClient: 'Erreur client',
  errorPartner: 'Erreur partenaire',
};

export const url = {
  helpLabel: Wording['WLOST-070'],
  phishing: 'Plus d’infos sur le phishing.',
};

export const link = {
  fillTemporaryPassword: Wording['WLOST-603'],
  getNewTemporaryPassword: Wording['WLOST-604'],
}

export const caption = {
  // Generic errors
  serviceDenied: Wording['WLOST-110'],
  locationDenied: Wording['WLOST-183'],
  technicalError: Wording['WLOST-189'],
  loginAfterDelay: Wording['WLOST-106'],
  useTemporaryPassword: Wording['WLOST-021'],
  connectLaterWithTempPassword: Wording['WLOST-254'],
  // Step 1
  login: Wording['WLOST-003'],
  yourAccount: Wording['WLOST-006'],
  captchaHelper: Wording['WLOST-023'],
  captchaSymbolWaiting: Wording['WLOST-005'],
  // Step 2
  contactMobile: Wording['WLOST-142'],
  contactMail: Wording['WLOST-143'],
  byMobile: 'Par sms : ',
  byMail: 'Par email : ',
  getLetter: Wording['WLOST-264'],
  contactSAV: Wording['WLOST-042'],
  isNotOwnerAccount: Wording['WLOST-043'],
  codeWillBeSentBySms: Wording['WLOST-057'],
  codeWillBeSentBySmsHidden: Wording['WLOST-063'],
  codeWillBeSentByMail: Wording['WLOST-056'],
  codeWillBeSentByMailHidden: Wording['WLOST-062'],
  noContactAccess: Wording['WLOST-034'],
  noEmailAccess: Wording['WLOST-049'],
  noMobileAccess: Wording['WLOST-046'],
  otherMethod: Wording['WLOST-280'],
  useOrangeTmpPwd: Wording['WLOST-605'],
  tmpPwdIndication: Wording['WLOST-606'],
  askNewTmpPwd: Wording['WLOST-607'],
  savSameAdvice: Wording['WLOST-608'],
  accessService: Wording['WLOST-609'],
  multibalCannotUseContactTitle: Wording['WLOST-281'],
  multibalCannotUseContactInfo: Wording['WLOST-282'],
  // Step 2 - Letter
  fillTwoDigitsPostalCode: '2 premiers chiffres du code postal',
  fillPostalCode: Wording['WLOST-266'],
  receiveLetterSoon: Wording['WLOST-269'],
  letterIndications: Wording['WLOST-157'],
  letterIsPending: Wording['WLOST-271'],
  postalCodeAttemptsExceeded: Wording['WLOST-165'],
  // Step 3
  maxSmsCodeAttempts: Wording['WLOST-091'],
  maxMailCodeAttempts: Wording['WLOST-092'],
  codeHelping: Wording['WLOST-066'],
  receiveCode: Wording['WLOST-029'],
  receiveCodeNsru: Wording['WLOST-055'],
  receiveCodeBySms: Wording['WLOST-051'],
  receiveCodeByMail: Wording['WLOST-048'],
  chooseContactWay: Wording['WLOST-055'],
  otcSentBySms: Wording['WLOST-074'],
  otcSentByMail: Wording['WLOST-075'],
  setCode: 'Saisissez votre code',
  noSmsReceived: Wording['WLOST-079'],
  noMailReceived: Wording['WLOST-080'],
  codeAttemptsExceeded: Wording['WLOST-087'],
  codeExpired: Wording['WLOST-193'],
  // Step 4
  changePasswordHelping: Wording['WLOST-099'],
  createNewPassword: Wording['WLOST-095'],
  confirmNewPassword: Wording['WLOST-096'],
  updatingPassword: 'Mise à jour de votre nouveau mot de passe en cours...',
  // Step 5
  addNewContacts: 'Ne perdez pas l\'accès à vos services Orange. Ajoutez un ou des moyens de contact, ils vous seront utiles si vous avez oublié votre mot de passe.',
  codeSentToUpdatePassword: 'Pour créer ou recréer votre mot de passe, un code vous sera envoyé par SMS ou email.',
  contactWaysAreHelpful: 'Vos moyens de contact serviront à vous adresser le code pour créer votre mot de passe.',
  haveNoMobile: Wording['WLOST-114'],
  haveNoMail: Wording['WLOST-126'],
  addMobile: Wording['WLOST-246'],
  addMail: Wording['WLOST-248'],
  mailCanManageAccount: Wording['WLOST-128'],
  setMobileLater: Wording['WLOST-116'],
  setMailLater: Wording['WLOST-130'],
  newContactsCanManageAccount: Wording['WLOST-118'],
  setNewContactsLater: Wording['WLOST-144'],
  // Step 6
  phishing: Wording['WLOST-151'],
  helpNewPassword: Wording['WLOST-140'],
  helpToChangePassword: Wording['WLOST-144'],
  serviceHelp: Wording['WLOST-602'],
};

export const button = {
  continue: Wording['WLOST-011'],
  validate: Wording['WLOST-158'],
  add: 'Ajouter',
  end: Wording['WLOST-022'],
  login: Wording['WLOST-145'],
  getLetter: Wording['WLOST-041'],
  tryAgain: Wording['WLOST-088'],
  copy: 'Copier les données',
  back: 'Retour',
  retryOtp: 'Renvoyer un code',
};

export const errorMessage = {
  technicalError: Wording['WLOST-103'],
  // Step 1
  noLogin: Wording['WLOST-013'],
  syntaxInvalid: Wording['WLOST-015'],
  invalidUser: Wording['WLOST-017'],
  unfinishedCaptcha: Wording['WLOST-026'],
  invalidCaptcha: Wording['WLOST-027'],
  // Step 3
  noOtpInput: Wording['WLOST-081'],
  otpIsNotANumber: Wording['WLOST-082'],
  otpIsIncorrect: Wording['WLOST-083'],
  // Step 4
  empty: 'Veuillez saisir votre nouveau mot de passe',
  invalid: 'Les 2 saisies ne correspondent pas',
  passwordConfirmEmpty: 'Veuillez confirmer votre mot de passe',
  notEqual: 'Les 2 saisies ne correspondent pas',
  isLogin: 'L’identifiant n’est pas un mot de passe valide',
  accentedChars: 'Les caractères accentués ne sont pas autorisés',
  space: 'L’espace n’est pas autorisé',
  specialChars: 'Les caractères spéciaux ne sont pas autorisés',
  tooShort: 'Mot de passe trop court',
  tooLong: 'Mot de passe trop long',
  samePassword: Wording['WLOST-279'],
  // Step 5
  mailIsInvalid: Wording['WLOST-134'],
  mailIsEmpty: Wording['WLOST-132'],
  mailIsUnknown: Wording['WLOST-136'],
  mobileIsInvalid: Wording['WLOST-122'],
  mobileIsEmpty: Wording['WLOST-120'],
  // Step 2 - Letter
  noPostalCode: Wording['WLOST-160'],
  postalCodeIsIncorrect: Wording['WLOST-162'],
};

export const placeholder = {
  emailOrMobile: Wording['WLOST-007'],
};

export const hint = {
  fillLogin: Wording['WLOST-010'],
  mailContact: 'Votre code de réinitialisation du mot de passe vous sera envoyé par email.<br>Pour des raisons de sécurité, votre email de contact peut être partiellement masqué.',
  mobileContact: 'Votre code de réinitialisation du mot de passe vous sera envoyé par SMS.<br>Pour des raisons de sécurité, votre numéro de mobile de contact peut être partiellement masqué.',
  multipleContacts: 'Choisissez le moyen de contact sur lequel vous souhaitez recevoir votre code de réinitialisation du mot de passe.<br>Pour des raisons de sécurité, vos moyens de contact peuvent être partiellement masqués.',
  step3: Wording['WLOST-066'],
  addContactAdvice: 'Un second moyen de contact facilite la réinitialisation du mot de passe de votre compte.',
  noContactAdvice: 'Sans moyen de contact, si votre mobile est volé ou perdu, vous ne serez plus en mesure de réinitialiser le mot de passe pour accéder à vos services d’Orange.',
};
